import React, { useState } from 'react';
import cn from 'classnames';

import { ReactComponent as ShowIcon } from 'assets/imgs/input-password-show.svg';
import { ReactComponent as HideIcon } from 'assets/imgs/input-password-hide.svg';
import Input from '../';
import classes from './inputPassword.module.scss';
import { IInputPassword } from './types';

const InputPassword: React.FC<IInputPassword> = ({
	className,
	value,
	onChange,
	onBlur,
	placeholder,
	error,
}) => {
	const [isVisible, setIsVisible] = useState(false);

	const handleToggleVisibility = (): void => {
		setIsVisible(!isVisible);
	};

	const showIcon = isVisible ? (
		<HideIcon
			className={classes.hideIcon}
			onClick={handleToggleVisibility}
		/>
	) : (
		<ShowIcon
			className={classes.showIcon}
			onClick={handleToggleVisibility}
		/>
	);

	return (
		<Input
			className={cn(classes.inputPassword, className)}
			value={value}
			onChange={onChange}
			onBlur={onBlur}
			placeholder={placeholder}
			type={isVisible ? 'text' : 'password'}
			endIcon={showIcon}
			error={error}
		/>
	);
};

export default InputPassword;
